import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { SyncOutline } from '@ant-design/icons-angular/icons';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTagModule } from 'ng-zorro-antd/tag';

import { GroupMatchConfigStoreModule } from '@libs/src/group-match-config/group-match-config-store.module';
import { GroupsStoreModule } from '@libs/src/groups/groups-store/groups-store.module';
import { DownloadCsvTemplateModule } from '@main-client/src/app/download-csv-template/download-csv-template.module';
import { TtcMatPaginatorModule } from '@main-client/src/app/ttc-mat-paginator/ttc-mat-paginator.module';
import { UploadCsvButtonModule } from '@main-client/src/app/upload-csv-button/upload-csv-button.module';

import { UploadCsvListDrawerService } from '@main-client/src/app/upload-csv-list-drawer/upload-csv-list-drawer.service';

import { UploadCsvListDrawerComponent } from './upload-csv-list-drawer.component';

@NgModule({
  declarations: [UploadCsvListDrawerComponent],
  imports: [
    CommonModule,
    DownloadCsvTemplateModule,
    FlexLayoutModule,
    GroupMatchConfigStoreModule,
    GroupsStoreModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    NzDrawerModule,
    NzIconModule.forChild([SyncOutline]),
    NzSpinModule,
    NzTagModule,
    TtcMatPaginatorModule,
    UploadCsvButtonModule,
  ],
  exports: [UploadCsvListDrawerComponent],
  providers: [UploadCsvListDrawerService],
})
export class UploadCsvListDrawerModule {}
